export type OutgoingDisplay = {id:string; phone:string; payload:any; previewPayload?:any; fileName?:string; created:number; state:'uploading'|'sending'|'accepted'|'failed'|'uncertain'; serverId?:string};
let rows:OutgoingDisplay[]=[];
const listeners=new Set<()=>void>();
const notify=()=>listeners.forEach(fn=>fn());
export const outgoingSnapshot=()=>rows;
export const subscribeOutgoing=(fn:()=>void)=>{listeners.add(fn);return ()=>{listeners.delete(fn);};};
export function beginOutgoing(payload:any,file?:any) {
 if(!payload.wa_id || payload.type==='reaction')return;
 const id=payload.pending_message_unique_id;
 if(!id)return;
 const old=rows.find(r=>r.id===id);
 const mediaType=file?.file?.type?.split('/')[0];
 const type=['image','video','audio'].includes(mediaType)?mediaType:'document';
 const previewPayload=file?{...payload,type,[type]:{link:file.fileURL,filename:file.file.name,caption:file.caption || ''}}:old?.previewPayload;
 rows=[...rows.filter(r=>r.id!==id),{...old,id,phone:payload.wa_id,payload,previewPayload,fileName:file?.file?.name || old?.fileName,created:old?.created || Date.now(),state:file?'uploading':'sending'}];notify();
}
export function updateOutgoing(id:string,patch:Partial<OutgoingDisplay>){rows=rows.map(r=>r.id===id?{...r,...patch}:r);notify();}
export function settleOutgoing(ids:string[]){const next=rows.filter(r=>!r.serverId || !ids.includes(r.serverId));if(next.length!==rows.length){rows=next;notify();}}
